import { useEffect } from 'react';

/**
 * Custom hook to handle dynamic validations with debouncing
 */

const useDynamicValidations = ({
  data,
  dependencyArray = [],
  dynamicValidations,
  performCustomValidations,
  debounce = 300,
  // fieldId,
}) => {
  useEffect(() => {
    let debounceValidations = null;
    if (dynamicValidations.length > 0 && !!data) {
      debounceValidations = setTimeout(() => {
        performCustomValidations({
          inputVal: data,
          validationsToPerform: dynamicValidations,
        });
      }, debounce);
    }
    return () => {
      if (debounceValidations) {
        clearTimeout(debounceValidations);
      }
    };
  }, [...dependencyArray]);
};

export default useDynamicValidations;
